import StyledToolTip from "customStyled/StyledToolTip";

const CustomTooltip = ({ title, placement="top", children, ...props }) => {
  return (
    <StyledToolTip
      title={title}
      arrow={true}
      placement={placement || "top"}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
      {...props}
    >
      {children}
    </StyledToolTip>
  );
};
export default CustomTooltip;
